import supabase from '../supabase/supabase';

export async function sendTestEmail() {
  const { data: sessionData, error: sessionError } = await supabase.auth.getSession();
  if (sessionError) throw sessionError;
  if (!sessionData.session) {
    throw new Error('Sign in as an administrator before sending a test email');
  }

  const { data, error } = await supabase.functions.invoke('send-guest-house-email', {
    body: {
      type: 'admin-test',
      metadata: {
        source: 'Guest house admin settings',
        requestedAt: new Date().toISOString()
      }
    }
  });

  if (error) throw error;
  if (data?.error) throw new Error(data.error);
  return data;
}

// Best-effort notification: a failed email must never block the saved enquiry.
export async function notifyNewEnquiry(enquiry) {
  try {
    await supabase.functions.invoke('send-guest-house-email', {
      body: { type: 'booking-enquiry', enquiry }
    });
  } catch {
    // The enquiry is already saved; the admin can still see it in the dashboard.
  }
}